import { Deserializable } from "./deserializable";

﻿export class CartItem {
    id: number;
    cartId: number;
    eventId: number;
    eventDate: Date;
    eventName: string;
    experienceName: string;
    experienceShortName: string;
    eventPerformerExperienceId: number;
    eventPerformerImageFilename: string;
    eventPerformerImageFilePath: string;
    eventPerformerName: string;
    price: number;
    quantity: number;
    maxPurchaseLimit: number;

    deserialize(input: any) {
        Object.assign(this, input);
        return this;
    }
}



// WEBPACK FOOTER //
// ./src/app/_models/cart-item.ts